window.addEventListener('load', () => {
    const links = document.querySelectorAll('.js-btn');

    links.forEach(link => {
        const span = link.querySelector('.js-magnet-round');

        let currentX = 0;
        let currentY = 0;

        let targetX = 0;
        let targetY = 0;

        const BASE_X = 18;
        const MAX_OFFSET_Y = 10;

        const animate = () => {
            currentX += (targetX - currentX) * 0.1;
            currentY += (targetY - currentY) * 0.1;

            span.style.transform = `translate(${currentX}px, ${currentY}px)`;
            requestAnimationFrame(animate);
        };

        animate();

        link.addEventListener('mousemove', (e) => {
            const { offsetY } = e;
            const { offsetHeight: height } = link;

            const normY = (offsetY / height - 0.5) * 2;

            targetX = BASE_X;
            targetY = normY * MAX_OFFSET_Y;
        });

        link.addEventListener('mouseleave', () => {
            targetX = 0;
            targetY = 0;
        });
    });
});
